import { createUseStyles } from 'react-jss'

import { colors } from '../variables.style'
import { color } from 'framer-motion'

export const style = {
  categoryContainer: {
    composes: 'flex-row',
    alignItems: 'center',
    fontSize: 18,
    backgroundColor: 'none',
    borderLeft: `2px solid var(--theme-header-bdr)`,
    borderTop: `2px solid var(--theme-header-bdr)`,
    borderTopLeftRadius: '5px',
    margin: '24px 0 16px',
    padding: '0 25px 0 10px'
  },
  downArrow: {
    display: 'block',
    fontSize: 14,
    color: 'var(--theme-header-fg)',
    width: 26,
    textAlign: 'center',
    cursor: 'pointer',

    '&:hover,&:focus': {
      color: 'var(--theme-header-bg)'
    }
  },
  upArrow: {
    display: 'block',
    fontSize: 14,
    color: 'var(--theme-header-fg)',
    width: 26,
    textAlign: 'center',
    cursor: 'pointer',

    '&:hover,&:focus': {
      color: 'var(--theme-header-bg)'
    }
  },
  category: {
    composes: 'flex-auto',
    color: 'var(--theme-header-fg)',
    padding: '6px 0',
    marginLeft: 9,
    textTransform: 'uppercase',
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
  },
  mark: {
    width: 20,
    height: 20
  },
  categoryTextFieldContainer: {
    margin: '24px 0 16px'
  },
  categoryTextField: {
    height: 33
  },
  editCategory: {
    color: color.headingColor,
    border: '1px solid transparent',
    padding: '6px 8px',
    fontSize: 15,
    cursor: 'pointer',

    '&:hover,&:focus': {
      color: 'var(--theme-brand-alt)',
      border: `1px solid var(--theme-brand-alt)`,
      backgroundColor: 'var(--theme-background)'
    }
  },
  deleteCategory: {
    extend: 'editCategory'
  }
}

export const useStyles = createUseStyles(style)
